<template>
  <div class="filters">
    <div
        class="filter-field"
        v-for="(apartmentsFilter, apartmentsFilterIndex) in apartmentsFilterOrder"
        :key="apartmentsFilterIndex"
        :style="{width: apartmentsFilter.width ? `calc(${apartmentsFilter.width} - 10px)` : '100%'}"
    >
      <template v-if="['dropdown','select'].includes(getFilterType(apartmentsFilter.value))">
        <filter-dropdown
            :value="getFilterValue(apartmentsFilter.value)"
            :show="true"
            :name="getFilterLabel(apartmentsFilter.value)"
            :options="getFilterOptions(apartmentsFilter.value)"
            @change="residenceFilter($event, getFilterKey(apartmentsFilter.value))"
        ></filter-dropdown>
      </template>
      <template v-if="getFilterType(apartmentsFilter.value) === 'slider'">
        <template v-if="apartmentsFilter.value === 'rooms'">
          <filter-slider
              v-model="roomsRange"
              :show="true"
              :label="getFilterLabel(apartmentsFilter.value)"
              :min="roomsMin"
              :max="roomsMax"
              @change="residenceFilter($event, getFilterKey(apartmentsFilter.value))"
          ></filter-slider>
        </template>
        <template v-else-if="apartmentsFilter.value === 'floors'">
          <div v-if="floorEntitiesEnabled" class="floors-entities">
            <fp-select-box
                v-model="filters.floor"
                :options="floorsEntities"
                :placeholder="getFilterLabel(apartmentsFilter.value)"
                @input="residenceFilter($event, 'floor')"
            ></fp-select-box>
          </div>
          <filter-slider
              v-else
              v-model="floorsRange"
              :show="true"
              :label="getFilterLabel(apartmentsFilter.value)"
              :min="floorsMin"
              :max="floorsMax"
              @change="residenceFilter($event, getFilterKey(apartmentsFilter.value))"
          ></filter-slider>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import apartmentsFilter from "@/components/ApartmentsFilter.vue";
import FilterDropdown from "@/components/apartments-filter/FilterDropdown.vue";
import FilterSlider from "@/components/apartments-filter/FilterSlider.vue";
import {mapGetters} from "vuex";
import FpSelectBox from "@/components/buttons/FpSelectBox.vue";

export default {
  name: "FiltersLoop",
  components: {FpSelectBox, FilterSlider, FilterDropdown},
  props: {
    defaultSettings: {
      type: Object,
      required: true,
    },
    value: {
      required: false
    },
    filteredProducts: {
      type: Array,
      required: false
    }
  },
  watch: {
    value: {
      handler(value){
        if (value) {
          const newValue = JSON.parse(JSON.stringify(value));
          if (JSON.stringify(newValue) !== JSON.stringify(this.modelValue)) {
            this.modelValue = newValue;
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  data(){
    return {
      modelValue: {
        building: null,
        rooms: null,
        floor: null,
        direction: null,
        apartment_sm: null,
        porch_sm: null,
        plots: null,
        quarters: null,
      }
    }
  },
  computed: {
    filters: {
      get(){
        return this.modelValue
      }
    },
    dynamicFields() {
      return this.settingsApartmentsFilter && this.settingsApartmentsFilter.dynamic_fields ? this.settingsApartmentsFilter.dynamic_fields : [];
    },
    customFields() {
      return this.settingsApartmentsFilter && this.settingsApartmentsFilter.custom_fields ? this.settingsApartmentsFilter.custom_fields : [];
    },
    apartmentsFilter() {
      return apartmentsFilter
    },
    defaultApartmentsFilterOrder(){
      const enabledFilters = [];
      if(this.settingsApartmentsFilter){
        const floorEnabled = this.settingsApartmentsFilter.floors && this.settingsApartmentsFilter.floors.show;
        const apartmentTypesEnabled = this.settingsApartmentsFilter.apartment_types && this.settingsApartmentsFilter.apartment_types.show;
        const buildingsEnabled = this.settingsApartmentsFilter.buildings && this.settingsApartmentsFilter.buildings.show;
        const roomsEnabled = this.settingsApartmentsFilter.rooms && this.settingsApartmentsFilter.rooms.show;
        //const apartmentSmEnabled = this.settingsApartmentsFilter.apartment_sm && this.settingsApartmentsFilter.apartment_sm.show;
        //const directionEnabled = this.settingsApartmentsFilter.direction && this.settingsApartmentsFilter.direction.show;
        //const porchSmEnabled = this.settingsApartmentsFilter.porch_sm && this.settingsApartmentsFilter.porch_sm.show;
        //const plotsEnabled = this.settingsApartmentsFilter.plots && this.settingsApartmentsFilter.plots.show;
        //const quartersEnabled = this.settingsApartmentsFilter.quarters && this.settingsApartmentsFilter.quarters.show;

        if(apartmentTypesEnabled){
          enabledFilters.push({
            value: 'apartment_types',
            title: this.$t('Apartment types'),
            width: '100%',
            type: 'dropdown'
          });
        }

        if(buildingsEnabled){
          enabledFilters.push({
            value: 'buildings',
            title: this.$t('Buildings'),
            width: '100%',
            type: 'dropdown'
          })
        }

        if(floorEnabled){
          enabledFilters.push({
            value: 'floors',
            title: this.$t('Floors'),
            width: '100%',
            type: 'slider'
          });
        }

        if(roomsEnabled){
          enabledFilters.push({
            value: 'rooms',
            title: this.$t('Rooms'),
            width: '100%',
            type: 'slider'
          })
        }

        /*if(apartmentSmEnabled){
          enabledFilters.push({
            value: 'apartment_sm',
            title: this.$t('Apartment sm'),
            width: '100%',
            type: 'dropdown'
          })
        }*/

        /*if(directionEnabled){
          enabledFilters.push({
            value: 'direction',
            title: this.$t('Direction'),
            width: '100%',
            type: 'dropdown'
          })
        }*/

        /*if(porchSmEnabled){
          enabledFilters.push({
            value: 'porch_sm',
            title: this.$t('Porch sm'),
            width: '100%',
            type: 'dropdown'
          })
        }*/

        /*if(plotsEnabled){
          enabledFilters.push({
            value: 'plots',
            title: this.$t('Plots'),
            width: '100%',
            type: 'dropdown'
          })
        }*/

        /*if(quartersEnabled){
          enabledFilters.push({
            value: 'quarters',
            title: this.$t('Quarters'),
            width: '100%',
            type: 'dropdown'
          })
        }*/

        if(this.dynamicFields.length){
          for(const field of this.dynamicFields){
            enabledFilters.push({
              value: field.filter_by_product_dynamic_field,
              title: field.filter_by_product_dynamic_field,
              width: '100%',
              type: field.type ?? 'select'
            })
          }
        }
        return enabledFilters;
      }
      return [];
    },
    apartmentsFilterOrder(){
      if (this.$store.getters.settings && this.$store.getters.settings.apartments_filter_order) {
        return this.$store.getters.settings.apartments_filter_order
      }
      return this.defaultApartmentsFilterOrder;
    },
    settingsApartmentsFilter() {
      if (this.$store.getters.settings && this.$store.getters.settings.apartments_filter) {
        return this.$store.getters.settings.apartments_filter
      }
      return this.defaultSettings
    },
    productsOrFilteredProducts(){
      if(this.filteredProducts && Array.isArray(this.filteredProducts)){
        return this.filteredProducts;
      }
      return this.products;
    },
    options(){
      const options = {};
      if (this.settingsApartmentsFilter.buildings.options) {
        options.building = this.settingsApartmentsFilter.buildings.options
      }

      if (this.settingsApartmentsFilter.plots.options) {
        options.plots = this.settingsApartmentsFilter.plots.options
      }

      if (this.settingsApartmentsFilter.rooms.options) {
        options.rooms = this.settingsApartmentsFilter.rooms.options
      }

      if (this.settingsApartmentsFilter.quarters.options) {
        options.quarters = this.settingsApartmentsFilter.quarters.options
      }

      if (this.settingsApartmentsFilter.apartment_types.options) {
        options.type = this.settingsApartmentsFilter.apartment_types.options
      }

      if (this.settingsApartmentsFilter.floors.options) {
        options.floor = this.settingsApartmentsFilter.floors.options
      }

      if (this.settingsApartmentsFilter.buildings && this.settingsApartmentsFilter.buildings.data_source === 'dynamic' && this.filter?.buildings) {
        options.building = this.filter?.buildings
      }

      if (this.settingsApartmentsFilter.plots && this.settingsApartmentsFilter.plots.data_source === 'dynamic' && this.filter?.plots) {
        options.plots = this.filter?.plots
      }

      if (this.settingsApartmentsFilter.quarters && this.settingsApartmentsFilter.quarters.data_source === 'dynamic' && this.filter?.quarters) {
        options.quarters = this.filter?.quarters
      }

      if (this.settingsApartmentsFilter.apartment_types && this.settingsApartmentsFilter.apartment_types.data_source === 'dynamic' && this.filter?.types) {
        options.type = this.filter?.types
      }

      if (this.settingsApartmentsFilter.floors && this.settingsApartmentsFilter.floors.data_source === 'dynamic' && this.filter?.floors) {
        options.floor = this.filter?.floors
      }

      if (this.productsOrFilteredProducts && Array.isArray(this.productsOrFilteredProducts)) {
        const available = {
          buildings: new Set(),
          types: new Set(),
          plots: new Set(),
          quarters: new Set(),
          floors: new Set(),
          rooms: new Set(),
        };
        this.productsOrFilteredProducts.forEach(p => {
          if (p.type_building) {
            if (p.type_building.id) available.buildings.add(String(p.type_building.id));
            if (p.type_building.name) available.buildings.add(String(p.type_building.name));
          } else if(p.building_id) {
            available.buildings.add(String(p.building_id));
          }
          if (p.apartment_type && p.apartment_type.id) available.types.add(String(p.apartment_type.id));

          if (p.plot_id) available.plots.add(String(p.p.plot_id));
          if (p.quarter_id) available.quarters.add(String(p.quarter_id));

          if (typeof p.floor !== 'undefined' && p.floor !== null) available.floors.add(String(p.floor));
          if (p.floor_name) available.floors.add(String(p.floor_name));
          if (p.floor_number) available.floors.add(String(p.floor_number));
          if (p.floor_id) available.floors.add(String(p.floor_id));

          if (p.type_rooms) available.rooms.add(String(p.type_rooms));
        });

        if (options.building && Array.isArray(options.building)) {
          options.building = options.building.filter(opt => available.buildings.has(String(opt.label || opt)));
        }
        if (options.plots && Array.isArray(options.plots)) {
          options.plots = options.plots.filter(opt => available.plots.has(String(opt.label || opt)));
        }
        if (options.quarters && Array.isArray(options.quarters)) {
          options.quarters = options.quarters.filter(opt => available.quarters.has(String(opt.label || opt)));
        }
        if (options.type && Array.isArray(options.type)) {
          options.type = options.type.filter(opt => available.types.has(String(opt.value || opt.label || opt)));
        }
        if (options.floor && Array.isArray(options.floor)) {
          options.floor = options.floor.filter(opt => available.floors.has(String(opt.label || opt)));
        }
        if (options.rooms && Array.isArray(options.rooms)) {
          options.rooms = options.rooms.filter(opt => available.rooms.has(String(opt.label || opt)));
        }
      }

      return options;
    },
    productsCustomFieldsOptionsSets(){
      const optionsSets = {};
      if(this.settingsApartmentsFilter && this.settingsApartmentsFilter.custom_fields && Array.isArray(this.settingsApartmentsFilter.custom_fields)){
        for(const customField of this.settingsApartmentsFilter.custom_fields){
          if(customField.type === 'select'){
            optionsSets[customField.key] = {
              ...customField,
              options: [],
            };
          }
        }
      }
      if(this.productsOrFilteredProducts && Array.isArray(this.productsOrFilteredProducts)){
        for(const product of this.productsOrFilteredProducts){
          if(product.custom_fields && Array.isArray(product.custom_fields)){
            for(const apartmentCustomField of product.custom_fields){
               if(optionsSets[apartmentCustomField.key]){
                 if(!optionsSets[apartmentCustomField.key].options){
                   optionsSets[apartmentCustomField.key].options = [];
                 }
                 if(optionsSets[apartmentCustomField.key].options.findIndex((option) => option === apartmentCustomField.value) === -1){
                   optionsSets[apartmentCustomField.key].options.push(apartmentCustomField.value);
                   optionsSets[apartmentCustomField.key].options.sort((optionA, optionB) => {
                     if(typeof(optionA) === 'string' && typeof(optionB) === 'string'){
                       return optionA.localeCompare(optionB);
                     }
                     if(typeof(optionA) == 'number' && typeof(optionB) == 'number'){
                       return optionA - optionB;
                     }
                     if(typeof(optionA) == 'string' && typeof(optionB) == 'number'){
                       return optionA.localeCompare(optionB);
                     }
                     if(typeof(optionA) == 'number' && typeof(optionB) == 'string'){
                       return optionA.localeCompare(optionB);
                     }
                     return 0;
                   });
                 }
               }
            }
          }
        }
      }
      return optionsSets;
    },
    productsDynamicFieldsOptionsSets(){
      if(this.productsOrFilteredProducts && Array.isArray(this.productsOrFilteredProducts)){
        const optionsSets = [];
        this.productsOrFilteredProducts.forEach((product) => {
          if(product.more_details && Array.isArray(product.more_details)){
            product.more_details.forEach((moreDetail) => {
              if(moreDetail && moreDetail.label && typeof(moreDetail.value) != "undefined"){
                const existingOption = optionsSets.find(optionSet => optionSet.label === moreDetail.label);
                if(existingOption){
                  existingOption.options.push(moreDetail.value);
                }else{
                  optionsSets.push({
                    label: moreDetail.label,
                    options: [moreDetail.value]
                  })
                }
              }
            })
          }
        });

        optionsSets.forEach((optionSet) => {
          // Filter out duplicate values in options
          optionSet.options = [...new Set(optionSet.options)];
          // sort values by abs and if numeric sort by number
          optionSet.options.sort((a, b) => {
            const numA = parseFloat(a);
            const numB = parseFloat(b);

            // Check if both are numeric
            if (!isNaN(numA) && !isNaN(numB)) {
              return numA - numB; // Sort numerically
            }

            // Fallback to string comparison if non-numeric
            if(typeof(a) === 'string' && typeof(b) === 'string'){
              return a.localeCompare(b);
            }
            return 0;
          });
        })

        return optionsSets;
      }
      return [];
    },
    dynamicFieldsFilters(){
      if(this.dynamicFields){
        return this.dynamicFields.map((fieldFilter) => {
          const options = this.getFilterOptions(fieldFilter.filter_by_product_dynamic_field);
          return {
            ...fieldFilter,
            options
          }
        });
      }
      return null
    },
    roomsMin() {
      if(this.settingsApartmentsFilter.rooms && this.settingsApartmentsFilter.rooms.data_source !== 'dynamic' && Array.isArray(this.settingsApartmentsFilter.rooms?.options)){
        const options = this.settingsApartmentsFilter.rooms.options.map(option => Number(option));
        return Math.min(...options)
      }
      if(this.products && this.products.length){
        return Math.min(...this.products.map(product => product.type_rooms))
      }
      return 0;
    },
    roomsMax() {
      if(this.settingsApartmentsFilter.rooms && this.settingsApartmentsFilter.rooms.data_source !== 'dynamic' && Array.isArray(this.settingsApartmentsFilter.rooms?.options)){
        const options = this.settingsApartmentsFilter.rooms.options.map(option => Number(option));
        return Math.max(...options)
      }
      if(this.products && this.products.length){
        return Math.max(...this.products.map(product => product.type_rooms))
      }
      return 0;
    },
    roomsRange: {
      get(){
        if(!this.filters.rooms){
          return [this.roomsMin, this.roomsMax];
        }
        return this.filters.rooms;
      },
      set(value){
        this.filters.rooms = value;
      }
    },
    floorsMin(){
      if(this.settingsApartmentsFilter.floors && this.settingsApartmentsFilter.floors.data_source === 'static' && Array.isArray(this.settingsApartmentsFilter.floors?.options)){
        const options = this.settingsApartmentsFilter.floors.options.map(option => Number(option));
        return Math.min(...options)
      }
      if(this.productFloorNumbers && this.productFloorNumbers.length){
        return Math.min(...this.productFloorNumbers)
      }
      return 0;
    },
    floorsMax(){
      if(this.settingsApartmentsFilter.floors && this.settingsApartmentsFilter.floors.data_source === 'static' && Array.isArray(this.settingsApartmentsFilter.floors?.options)){
        const options = this.settingsApartmentsFilter.floors.options.map(option => Number(option));
        return Math.max(...options)
      }
      if(this.productFloorNumbers && this.productFloorNumbers.length){
        return Math.max(...this.productFloorNumbers)
      }
      return 0;
    },
    floorsRange: {
      get(){
        if(!this.filters.floor){
          return [this.floorsMin, this.floorsMax];
        }
        return this.filters.floor;
      },
      set(value){
        this.filters.floor = value;
      }
    },
    floorEntitiesEnabled(){
      if(this.settingsApartmentsFilter.floors && this.settingsApartmentsFilter.floors.data_source === 'dynamic-entities'){
        return this.$store.getters.settings && this.$store.getters.settings.floor_entities;
      }
      return false;
    },
    floorsEntities(){
      if(this.$store.getters.filter && this.$store.getters.filter.floors){
        return this.$store.getters.filter.floors;
      }
      return [];
    },
    productFloorNumbers(){
      if(this.products && Array.isArray(this.products) && this.products.length){
        return this.products.map(product => product.floor_number).filter(floorNumber => typeof(floorNumber) === 'number');
      }
      return [];
    },
    ...mapGetters(['filter','products'])
  },
  methods: {
    residenceFilter(option, filterName) {
      if(option && option.value === null) {
        this.filters[filterName] = null;
      }else if (this.floorEntitiesEnabled && filterName === 'floor' && option.value) {
        this.filters[filterName] = option.value;
      }else if (Array.isArray(option) && option.length === 2 && filterName === 'floor') {
        this.filters[filterName] = option;
      }else{
        this.filters[filterName] = option.label || option
      }
      this.$emit('filters', this.filters)
    },
    getFilterLabel(filterValue){
      switch (filterValue) {
        case 'apartment_types':
          return this.$t('טיפוס');
        case 'buildings':
          return this.$t('בניין')
        case 'floors':
          if(this.floorEntitiesEnabled){
            return this.$t('קומה')
          }
          return this.$t('קומות')
        case 'rooms':
          return this.$t('חדרים')
        default:
          if(filterValue.length === 32){
            const customField = this.productsCustomFieldsOptionsSets[filterValue];
            if(customField && customField.label){
              return customField.label;
            }
          }
          if(this.dynamicFields && this.dynamicFields.length){
            const dynamicFilterField = this.dynamicFields.find(df => df && df.filter_by_product_dynamic_field === filterValue);
            if(dynamicFilterField){
              return dynamicFilterField.label ?? dynamicFilterField.filter_by_product_dynamic_field;
            }
          }
          return 'no label'
      }
    },
    getFilterKey(filterValue){
      switch (filterValue) {
        case 'apartment_types':
          return 'type';
        case 'buildings':
          return 'building';
        case 'quarters':
          return 'quarter';
        case 'plots':
          return 'plot';
        case 'porch_sm':
          return 'porch_sm';
        case 'direction':
          return 'direction';
        case 'apartment_sm':
          return 'apartment_sm';
        case 'floors':
          return 'floor';
        case 'rooms':
          return 'rooms';
        default:
          return filterValue;

      }
    },
    getFilterValue(filterValue){
      if(this.filters){
        switch (filterValue) {
          case 'apartment_types':
            return this.filters.type;
          case 'buildings':
            return this.filters.building;
          case 'quarters':
            return this.filters.quarter;
          case 'plots':
            return this.filters.plot;
          case 'porch_sm':
            return this.filters.porch_sm;
          case 'direction':
            return this.filters.direction;
          case 'apartment_sm':
            return this.filters.apartment_sm;
          case 'floors':
            return this.filters.floor;
          case 'rooms':
            return this.filters.rooms;
          default:
            if(this.filters[filterValue]){
              return this.filters[filterValue];
            }
            return null;
        }
      }
      return null;
    },
    getFilterType(filterValue){
      switch (filterValue) {
        case 'apartment_types':
        case 'buildings':
        case 'quarters':
        case 'plots':
        case 'porch_sm':
        case 'direction':
        case 'apartment_sm':
          return 'dropdown';
        case 'floors':
        case 'rooms':
          return 'slider'
        default:
            if(this.dynamicFields && this.dynamicFields.length){
              const dynamicFilterField = this.dynamicFields.find(df => df && df.filter_by_product_dynamic_field === filterValue);
              if(dynamicFilterField && dynamicFilterField.type){
                return dynamicFilterField.type ?? 'select';
              }
            }
            return 'select';

      }
    },
    getFilterOptions(filterValue){
      switch (filterValue) {
        case 'apartment_types':
          return this.options.type;
        case 'buildings':
          return this.options.building;
        case 'floors':
          return this.options.floor;
        case 'rooms':
          return this.options.rooms;
        case 'quarters':
          return this.options.quarters;
        case 'plots':
          return this.options.plots;
        case 'porch_sm':
          return this.options.porch_sm;
        case 'direction':
          return this.options.direction;
        case 'apartment_sm':
          return this.options.apartment_sm;
        default:
          if(filterValue.length === 32){
            const customField = this.productsCustomFieldsOptionsSets[filterValue];
            if(customField && customField.options){
              return customField.options;
            }
            return [];
          }
          if(this.dynamicFields && this.dynamicFields.length){
            const options = this.productsDynamicFieldsOptionsSets.find(optionSet => optionSet.label === filterValue);
            if(options){
              return options.options;
            }
          }
          return [];
      }
    }
  },
  mounted(){
    if(this.dynamicFieldsFilters){
      this.dynamicFieldsFilters.forEach((dynamicField) => {
        this.filters[dynamicField.filter_by_product_dynamic_field] = null;
      })
    }
  }
}
</script>
<style scoped>
.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>